import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const Twentyfirsttheme = ({get_data}) => {
    const navigate = useNavigate();
    const [cartCount, setCartCount] = useState(0);
    const [visibleCategories, setVisibleCategories] = useState(12);

    React.useEffect(() => {
        const updateCount = () => {
            const storedCart = localStorage.getItem('cart');
            const cartItems = storedCart ? JSON.parse(storedCart) : [];
            const count = cartItems.reduce((acc, item) => acc + (item.quantity || 1), 0);
            setCartCount(count);
        };

        updateCount();
        window.addEventListener('storage', updateCount);
        window.addEventListener('cartUpdated', updateCount);

        return () => {
            window.removeEventListener('storage', updateCount);
            window.removeEventListener('cartUpdated', updateCount);
        };
    }, []);

    const [cart, setCart] = useState([]);

        const addToCart = (service) => {
        const storedCart = localStorage.getItem('cart');
        let cartItems = storedCart ? JSON.parse(storedCart) : [];
        
        // Check if item already exists
        const existingItemIndex = cartItems.findIndex(item => 
            (item.id && service.id && item.id === service.id) || 
            (item.service_name && service.service_name && item.service_name === service.service_name)
        );
        
        if (existingItemIndex > -1) {
            cartItems[existingItemIndex].quantity = (cartItems[existingItemIndex].quantity || 1) + 1;
        } else {
            cartItems.push({ ...service, quantity: 1 });
        }

        localStorage.setItem('cart', JSON.stringify(cartItems));
        window.dispatchEvent(new Event('cartUpdated'));
        // alert(`Added ${service.service_name} to cart`);
        navigate('/cart');
    };

    return (
        <>
            <style>{`
        :root {
            --primary: #be123c; /* Rose 700 */
            --secondary: #881337; /* Rose 900 */
            --accent: #fb7185; /* Rose 400 */
            --bg: #fff1f2;
        }
        body { margin: 0; font-family: 'Nunito', sans-serif; background: var(--bg); color: var(--secondary); }
        .container { max-width: 1000px; margin: 0 auto; padding: 20px; }
        
        .header-main { background: var(--secondary); padding: 20px 0; color: white; border-bottom: 5px solid var(--primary); }
        .header-inner { display: flex; justify-content: space-between; align-items: center; }
        
        .hero { background: linear-gradient(135deg, #be123c, #fb7185); color: white; padding: 80px 20px; text-align: center; border-radius: 20px; margin: 30px auto; box-shadow: 0 20px 40px -10px rgba(190, 18, 60, 0.4); }
        .hero h1 { font-size: 3rem; margin-bottom: 10px; }
        
        .btn { background: white; color: var(--primary); padding: 12px 30px; border-radius: 50px; font-weight: 800; border: 2px solid white; cursor: pointer; transition: 0.3s; display: inline-block; }
        .btn:hover { background: transparent; color: white; }
        
        .card { background: white; padding: 30px; border-radius: 20px; box-shadow: 0 10px 25px -5px rgba(0,0,0,0.05); text-align: center; transition: 0.3s; }
        .card:hover { transform: translateY(-5px); box-shadow: 0 20px 25px -5px rgba(0,0,0,0.1); }
        
        .grid { display: grid; grid-template-columns: repeat(auto-fill, minmax(280px, 1fr)); gap: 30px; margin-top: 40px; }
        
        .circle-icon { width: 80px; height: 80px; background: var(--bg); border-radius: 50%; display: flex; align-items: center; justify-content: center; margin: 0 auto 20px; font-size: 2rem; color: var(--primary); }
        
        .footer { background: white; margin-top: 80px; padding: 40px 0; text-align: center; border-top: 1px solid #ffdce0; }
            `}</style>
            <link href="https://fonts.googleapis.com/css2?family=Nunito:wght@400;700;900&display=swap" rel="stylesheet" />

            <div className="header-main">
                <div className="container header-inner">
                    <div style={{fontSize: '1.5rem', fontWeight: 900}}>{get_data.service_name}</div>
                    <div>
                        <a href="#services" style={{color: 'white', marginRight: '20px', fontWeight: 700}}>Services</a>
                        <a href="#products" style={{color: 'white', fontWeight: 700}}>Store</a>
                    </div>
                </div>
            </div>

            <div className="container">
                <div className="hero">
                    <h1>Bold. Vibrant. You.</h1>
                    <p style={{fontSize: '1.2rem', marginBottom: '30px'}}>Experince the burst of quality services.</p>
                    <a href="#products" className="btn">Shop Now</a>
                </div>
                
                <h2 style={{textAlign: 'center', fontSize: '2.5rem', marginTop: '80px'}}>Services</h2>
                <div className="grid">
                     {get_data.all_categories && get_data.all_categories.slice(0, visibleCategories).map((item, index) => (
                        <div className="card" key={index}>
                            <div className="circle-icon">
                                 {item.icon ? <img src={item.icon.startsWith('http') ? item.icon : `https://reliep-images.s3.ap-south-1.amazonaws.com/public/storage/${item.icon}`} style={{width: '50%', height: '50%', objectFit: 'cover'}} alt=""/> : <span>✿</span>}
                            </div>
                            <h3>{item.name}</h3>
                            <p>{item.description}</p>
                            <div style={{display: 'flex', gap: '10px', justifyContent: 'center', marginTop: '10px'}}>
                                <a href={`tel:${get_data.mobile}`} style={{color: 'var(--primary)', fontWeight: 'bold', border: '1px solid var(--primary)', padding: '5px 15px', borderRadius: '15px'}}>Call</a>
                                <a href="#contact" style={{background: 'var(--primary)', color: 'white', fontWeight: 'bold', padding: '5px 15px', borderRadius: '15px'}}>Enquire</a>
                        <a href="/cart" style={{display: 'flex', alignItems: 'center', position: 'relative', marginLeft: '15px', color: 'inherit', textDecoration: 'none'}}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                <circle cx="9" cy="21" r="1"></circle>
                                <circle cx="20" cy="21" r="1"></circle>
                                <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"></path>
                            </svg>
                            {cartCount > 0 && (
                                <span style={{
                                    position: 'absolute',
                                    top: '-8px',
                                    right: '-10px',
                                    background: 'red',
                                    color: 'white',
                                    borderRadius: '50%',
                                    width: '20px',
                                    height: '20px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    fontSize: '0.7rem',
                                    fontWeight: 'bold'
                                }}>
                                    {cartCount}
                                </span>
                            )}
                        </a>
                            </div>
                        </div>
                     )) }
                    { get_data.all_categories && visibleCategories < get_data.all_categories.length && (
                        <div style={{textAlign: 'center', marginTop: '40px'}}>
                            <button 
                                onClick={() => setVisibleCategories(prev => prev + 6)} 
                                className="btn"
                            >
                                Show More
                            </button>
                        </div>
                    )}
                </div>

                <h2 style={{textAlign: 'center', fontSize: '2.5rem', marginTop: '80px'}}>Products</h2>
                <div className="grid">
                    {get_data.product_services && get_data.product_services.map((item, index) => (
                        <div className="card" key={index} style={{cursor: 'pointer'}} onClick={() => addToCart(item)}>
                             {item.featured_image ? (<img src={item.featured_image && item.featured_image.startsWith('http') ? item.featured_image : `https://reliep-snaps.s3.ap-south-1.amazonaws.com/featured/${item.featured_image}`} style={{width: '100%', height: '200px', objectFit: 'cover', borderRadius: '10px'}} alt=""/>) : (<div className="" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#f0f0f0', fontSize: '1.5rem', fontWeight: 'bold', color: '#555', width: '100%', height: '200px', objectFit: 'cover', borderRadius: '10px' }}>{(item.service_name || 'PR').slice(0, 2).toUpperCase()}</div>)}
                            <h3>{item.service_name}</h3>
                            {item.price && <div style={{color: 'var(--primary)', fontSize: '1.2rem', fontWeight: 800}}>₹{item.price}</div>}
                            <button className="btn" style={{background: 'var(--primary)', color: 'white', border: 'none', marginTop: '10px'}}>Add</button>
                        </div>
                    ))}
                </div>
            </div>

            <div className="footer" id="contact">
                <div className="container">
                    <h3>{get_data.service_name}</h3>
                    <p>{get_data.business_location_name} | {get_data.mobile}</p>
                    <p>&copy; 2024</p>
                </div>
            </div>
        </>
    );
};

export default Twentyfirsttheme;
